// extracted by mini-css-extract-plugin
module.exports = {"cancel-subscription-modal__text":"styles_cancel-subscription-modal__text__1wfzP","cancel-subscription-modal__button":"styles_cancel-subscription-modal__button__2Wo3S"};